import { Image } from "primereact/image";
import "primeicons/primeicons.css";
import { Key } from "react";

const socialLinks = [
  {
    href: "https://bsky.app/profile/myembassymycons.bsky.social",
    icon: "pi pi-globe",
  },
  {
    href: "https://www.facebook.com/myembassymyconsulate",
    icon: "pi pi-facebook",
  },
  {
    href: "https://www.instagram.com/myembassymyconsulate",
    icon: "pi pi-instagram",
  },
  {
    href: "https://pf.kakao.com/_xhwNSs",
    icon: "pi pi-globe",
  },
  {
    href: "https://line.me/R/ti/p/@128jtaxv",
    icon: "pi pi-globe",
  },
  {
    href: "https://www.linkedin.com/company/myembassymyconsulate",
    icon: "pi pi-linkedin",
  },
  {
    href: "https://mastodon.social/@myembassymyconsulate ",
    icon: "pi pi-globe",
  },
  {
    href: "https://substack.com/@myembassymyconsulate",
    icon: "pi pi-globe",
  },
  {
    href: "https://t.me/myembassymyconsulate",
    icon: "pi pi-globe",
  },
  {
    href: "https://www.threads.com/@myembassymyconsulate",
    icon: "pi pi-globe",
  },
  {
    href: "https://invite.viber.com/?g2=AQBpHNaD%2FdMpplL5hQR0XABwu63r9cxeuRq5jEd5EYtca3ecSrGVERtrbHsiFMRJ",
    icon: "pi pi-globe",
  },
  {
    href: "https://vk.com/myembassymyconsulate",
    icon: "pi pi-globe",
  },
  {
    href: "https://www.whatsapp.com/channel/0029Va9PJU9HgZWTv4VkXs2L",
    icon: "pi pi-globe",
  },
  {
    href: "https://x.com/myembassymycons",
    icon: "pi pi-twitter",
  },
];

const renderSocialLink = (
  { href, src, alt, icon }: any,
  index: Key | null | undefined
) => (
  <a
    key={index}
    href={href}
    target="_blank"
    style={{ margin: "0 0.5rem", color: "black" }}
  >
    {src ? <Image src={src} alt={alt} width="16" /> : <i className={icon}></i>}
  </a>
);

export const MySocialNetworks = () => {
  return (
    <div className="flex justify-content-center">
      {socialLinks.map(renderSocialLink)}
    </div>
  );
};
